import React, { useState, useEffect } from 'react'
import { withOktaAuth } from "@okta/okta-react";
import ContributorListSelector from "./ContributorListSelector";
//import { contributors } from '../helpers/contributors'
import { getContributorList } from "../helpers/api";
import { connect } from "react-redux";
import Processing from "./misc/processing";
import Placeholder from "./misc/placeholder";
import arraySort from "array-sort";
import { CONSTANTS } from "../helpers/constants";
import CountryTable from "./CountryTable";
import OrgTable from "./OrgTable";

const ContributorList = ({ user }) => {
  const [countries, setCountries] = useState([])
  const [groups, setGroups] = useState([
    {
      id: 0,
      name: "All",
      filter: [],
      isOrgTable: true,
      selected: true,
    },
    {
      id: 1,
      name: "Countries",
      filter: [{ ContributorType: "Country" }],
    },
    {
      id: 2,
      name: "G7",
      filter: [{ G7: true }],
    },
    {
      id: 3,
      name: "G20",
      filter: [{ G20: true }],
    },
    {
      id: 4,
      name: "Organizations",
      filter: [{ ContributorType: "Organization" }],
      isOrgTable: true,
    },
  ]);
  const [search, setSearch] = useState(null)
  const [sortBy, setSortBy] = useState({
    key: "ContributorName",
    type: "asc",
  })
  const [cols, setCols] = useState([
    {
      label: "Contributor",
      id: "ContributorName",
      colSpan: 2,
    },
    {
      label: "Announced",
      id: "AnnouncedUSD",
      className: "text-right",
    },
    {
      label: "Signed",
      id: "SignedUSD",
      className: "text-right",
    },
    {
      label: "Signed per capita",
      id: "SignedPC",
      className: "text-right",
      countryField: true,
    },
    {
      label: "GDP per capita",
      id: "GDPPC",
      className: "text-right",
      countryField: true,
    },
    {
      label: "Emissions per capita",
      id: "EmissionsPC",
      className: "text-center nowrap",
      countryField: true,
    },
  ]);

  useEffect(() => {
    document && (document.title = `${CONSTANTS.APP_TITLE}`)
    if (user) {
      getContributorList()
        .then((data) => {
          setCountries(data)
        });
    }

  }, [user])

  const setGroup = (id) => {
    setGroups((prev) => ({
      groups: prev.groups.map((g) => {
        g.selected = false;
        if (g.id === id) {
          g.selected = true;
        }
        return g;
      }),
    }));
  };

  const handleSorting = (e, key) => {
    e.preventDefault();
    setSortBy((prev) => ({
      ...prev,
      sortBy: {
        key: key,
        type:
          prev.sortBy.key === key
            ? prev.sortBy.type === "asc"
              ? "desc"
              : "asc"
            : "desc",
      },
    }));
  };

  const handleSearch = (val) => {
    setSearch({
      search: val,
    });
    if (val && val.length > 0) {
      setGroup(0);
    }
  };

  //let { countries, groups, sortBy, cols, search } = this.state;
  //console.warn({ user: this.props.user })
  if (!user) {
    return <Processing />;
  }

  const selectedGroup = groups.filter((g) => g.selected)[0];
  //arraySort(countries, 
  const countriesData = countries && Array.isArray(countries) ? arraySort(countries.map((c) => {
    let flag = true;
    c.hidden = false;
    selectedGroup.filter.forEach((filter) => {
      Object.keys(filter).forEach((key) => {
        if (c[key] !== filter[key]) {
          flag = false;
          return false;
        }
      });
    });
    if (
      !flag ||
      (search &&
        search.length &&
        (c.CountryName || c.Name)
          .toLowerCase()
          .indexOf(search.toLowerCase()) === -1)
    ) {
      c.hidden = true;
    }
    return c;
  }), sortBy.key, {
    reverse: sortBy.type === "desc",
  }) : null

  if(!countriesData){
    return <Processing />
  }

  return (
    <React.Fragment>
      <div className="container">
        <div className="row">
          <div className="col-12 col-sm-7 col-md-8">
            <ContributorListSelector
              groups={groups}
              onSelect={(group_id) => setGroup(group_id)}
            />
          </div>
          <div className="col-12 col-sm-5 col-md-4">
            <div className="input-group mt-3">
              <input
                type="text"
                className="form-control"
                placeholder="Search Contributor..."
                value={search || ""}
                onChange={(e) => handleSearch(e.target.value)}
              ></input>
              <div className="input-group-append">
                <div className="input-group-text">
                  <i className="fas fa-search" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col">
            <div className="table-responsive mt-3">
              {!selectedGroup.isOrgTable ? (
                <CountryTable
                  cols={cols}
                  countries={countriesData}
                  handleSorting={handleSorting}
                  sortBy={sortBy}
                />
              ) : (
                <OrgTable
                  cols={cols}
                  data={countriesData}
                  handleSorting={handleSorting}
                  sortBy={sortBy}
                />
              )}
              {(!countriesData || countriesData.length === 0) && <Placeholder />}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );

}

const mapStateToProps = ({ okta }) => {
  return {
    user: okta && okta.user,
    isOktaFetching: okta && okta.isFetching,
  };
};

export default withOktaAuth(connect(mapStateToProps, null)(ContributorList));
